import React, { useRef, useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";
import ResumeSubUseForm from "../../../hooks/editor/resumeSubUseForm";
import { useTranslation } from "react-i18next";
import ChangeResumeOrder from "../../../hooks/editor/changeResumeOrder";
import ContentEditable from "../../../Components/ContentEditable/ContentEditable";
import Quilleditor from "../../../Components/Quilleditor/Quilleditor";
import DatePicker from "../../../Components/DatePicker/datePicker";
import SectionToolbar from "../../../Components/GlobalSectionToolbar/SectionToolbar";
import SectionItemToolbar from "../../../Components/GlobalSectionToolbar/SectionItemToolbar";
import parse from "html-react-parser";
import SectionHeader from "../SectionHeader/sectionHeader";
import EducationItem from "./EducationItem";

import { Header1 } from "./Header/Header1";
import { Header2 } from "./Header/Header2";
import { Header3 } from "./Header/Header3";
import SectionItemWrapper from "../SectionItemWrapper/SectionItemWrapper";

function Education(props) {
  const {
    resumeFields,
    sectionId,
    resumeTitleHandler,
    handleEditorChange,
    resumeHandler,
    resumeUpdate,
    dateHandler,
    styles,
    settings,
    handleSliderChange,
    PageMargin,
    SectionMargin,
    layout,
  } = props;
  const [t, i18n] = useTranslation("common");
  const { json, setJson, jsonIndex, setJsonIndex, isJson, setIsJson } =
    useContext(jsonEditorContext);

  const editorSettings = useSelector(
    (state) => state.editorData.editorSettings
  );

  const { education } = settings;

  const [showQuillToolbar, setShowQuillToolbar] = useState(true);

  const changesetShowQuillToolbar = (status) => {
    setShowQuillToolbar(status);
  };

  const [showSettings, setShowSettings] = useState(false);
  const [focusIndex, setFocusIndex] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isSelectedFrom, setIsSelectedFrom] = useState(true);

  //UseForm

  const { showHideElements } = ResumeSubUseForm(props.sectionId);

  const { sectionMoveUp, sectionMoveDown } = ChangeResumeOrder();

  const innerSectionClick = (e, index, action) => {
    if (action == "quill") {
      props.changeFocusStyle(props.sectionId, index.toString(), "item", true);
    } else {
      props.changeFocusStyle(props.sectionId, index.toString(), "item");
    }
  };

  useEffect(() => {
    setFocusIndex(false);
  }, []);

  let headerHtml;
  if (education.headerStyle == "Header1") {
    headerHtml = Header1;
  } else if (education.headerStyle == "Header2") {
    headerHtml = Header2;
  } else if (education.headerStyle == "Header3") {
    headerHtml = Header3;
  } else {
    headerHtml = Header1;
  }

  const mainSectionClick = (e, title) => {
    props.changeFocusStyle(props.sectionId, false, "section");
  };

  const handleDatePicker = () => {
    setShowDatePicker(!showDatePicker);
  };
  //   useEffect(() => {
  //     setShowDatePicker(false);
  //   }, [props]);

  useEffect(() => {
    if (props.newSectionFocus != props.sectionId) {
      setShowDatePicker(false);
      setIsSelectedFrom(true);
    }
  }, [props.newSectionFocus]);

  return (
    <>
      {resumeFields && resumeFields.show && (
        <>
          <>
            <SectionHeader
              styles={styles}
              settings={settings}
              resumeFields={resumeFields}
              sectionId={sectionId}
              resumeTitleHandler={resumeTitleHandler}
              resumeUpdate={resumeUpdate}
              PageMargin={PageMargin}
              SectionMargin={SectionMargin}
            />
            <div className="section-item-wrapper education-item-wrapper">
              {props &&
                props.response &&
                props.response.itemIndexes.map(
                  (result, ind) =>
                    resumeFields &&
                    resumeFields.data &&
                    resumeFields.data.map((response, index, row) =>
                      index == result ? (
                        <>
                          <SectionItemWrapper
                            sectionId={sectionId}
                            styles={styles}
                            layout={layout}
                            index={index}
                            newSectionFocus={props.newSectionFocus}
                            currentStateFocus={props.currentStateFocus}
                            newItemFocus={props.newItemFocus}
                            SectionMargin={SectionMargin}
                            isFixedPaddingBottom={true}
                            paddingBottom={"10px"}
                            onMouseDown={(e) => e.stopPropagation()}
                            onClick={(e) => {
                              e.stopPropagation();
                              innerSectionClick(e, index);
                            }}
                            style={{ position: "relative" }}
                          >
                            {showQuillToolbar &&
                              props.newSectionFocus == props.sectionId &&
                              props.currentStateFocus == "item" &&
                              props.newItemFocus &&
                              props.newItemFocus == index.toString() && (
                                <SectionItemToolbar
                                  index={index}
                                  indexString={index.toString()}
                                  handleDelete={props.handleItemDelete}
                                  addAdditionalField={props.addAdditionalField}
                                  sectionItemMoveUp={props.sectionItemMoveUp}
                                  sectionItemMoveDown={
                                    props.sectionItemMoveDown
                                  }
                                  row={row}
                                  sectionId={props.sectionId}
                                  startFrom={response.startFrom}
                                  endUntil={response.endUntil}
                                  resumeUpdate={resumeUpdate}
                                  dateHandler={dateHandler}
                                  showDatePicker={showDatePicker}
                                  newSectionFocus={props.newSectionFocus}
                                  isSelectedFrom={isSelectedFrom}
                                  response={response}
                                  changeSettings={props.changeSettings}
                                  handleSliderChange={handleSliderChange}
                                />
                              )}
                            <EducationItem
                              headerHtml={education?.headerStyle}
                              styles={styles}
                              resumeHandler={resumeHandler}
                              resumeUpdate={resumeUpdate}
                              response={response}
                              index={index}
                              handleDatePicker={handleDatePicker}
                              handleEditorChange={handleEditorChange}
                              changesetShowQuillToolbar={
                                changesetShowQuillToolbar
                              }
                              showQuillToolbar={showQuillToolbar}
                              sectionId={props.sectionId}
                            />
                          </SectionItemWrapper>
                        </>
                      ) : (
                        ""
                      )
                    )
                )}
            </div>
          </>
        </>
      )}
    </>
  );
}
export default Education;
